import { render, staticRenderFns } from "./AccomodationsValuesInputs.vue?vue&type=template&id=81f1083c&scoped=true&"
import script from "./AccomodationsValuesInputs.vue?vue&type=script&lang=js&"
export * from "./AccomodationsValuesInputs.vue?vue&type=script&lang=js&"
import style0 from "./AccomodationsValuesInputs.vue?vue&type=style&index=0&id=81f1083c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f1083c",
  null
  
)

export default component.exports